/**
 * @file ImpersonationOrphanNotice.tsx
 * @description «У вас уже есть активный вход под сотрудником» в окне
 * «Войти как…» (phase06; вынесено из ImpersonationStartModal в phase19.28,
 * чтобы окно с полем причины осталось ≤ 200 строк). Подключиться к старой
 * сессии или завершить её.
 */

import { Alert } from "./ui/alert";
import { Button } from "./ui/button";
import type { ActiveImpersonation } from "../lib/api-impersonation";

interface Props {
  orphan: ActiveImpersonation;
  error: string | null;
  action: null | "adopt" | "stop";
  onAdopt: () => void;
  onStop: () => void;
}

export function ImpersonationOrphanNotice({ orphan, error, action, onAdopt, onStop }: Props) {
  return (
    <div className="flex flex-col gap-3">
      <Alert severity="warning" title="У вас уже есть активный вход под сотрудником">
        Под учётной записью: <strong>{orphan.target.email}</strong>
        <br />
        Начат:{" "}
        {new Date(orphan.startedAt).toLocaleString("ru-RU", {
          day: "2-digit",
          month: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        })}
        {orphan.reason ? (
          <>
            <br />
            Причина: {orphan.reason}
          </>
        ) : null}
      </Alert>
      <p className="text-sm text-on-surface-variant">
        Подключитесь к существующему входу или завершите его, чтобы начать новый.
      </p>
      {error ? <Alert severity="error">{error}</Alert> : null}
      <div className="flex flex-col gap-2 sm:flex-row">
        <Button
          // Завершить чужую сессию — «отключить»: красный.
          variant="destructive"
          onClick={onStop}
          disabled={action !== null}
          className="flex-1"
        >
          {action === "stop" ? "Завершаем…" : "Завершить старый"}
        </Button>
        <Button onClick={onAdopt} disabled={action !== null} className="flex-1">
          {action === "adopt" ? "Подключаемся…" : "Подключиться к старому"}
        </Button>
      </div>
    </div>
  );
}
